import React from 'react'
import { Box, Typography, Tabs, Tab } from '@mui/material'
import AnnouncementIcon from '@mui/icons-material/Announcement'
import LaunchIcon from '@mui/icons-material/Launch'
import { useDispatch, useSelector } from 'react-redux'
import { styled } from '@mui/material/styles'
import ReleaseNotes from './releaseNotes'
import Announcements from './announcements'
import {
  getAdminData,
  setDialogDataAction,
  updateAdminData
} from '../../store/pages/adminTool'

const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginTop: theme.spacing(2),
  flexDirection: 'row',
  backgroundColor: 'white'
}))

const StyledTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.text.primary,
  padding: theme.spacing(1, 2, 0.5, 2),
  marginRight: theme.spacing(2),
  textTransform: 'none',
  '&:hover': {
    color: theme.palette.error.main
  },
  '&.Mui-selected': {
    color: theme.palette.text.primary
  }
}))

const getTabContents = (dispatch, tab, releaseData, announcementData) => {
  switch (tab) {
    case 'Announcements':
      return (
        <Announcements
          data-testid="view-announcement"
          data={announcementData}
          update={(data) => dispatch(updateAdminData(data))}
        />
      )
    case 'Release Notes':
      return (
        <ReleaseNotes
          data-testid="view-releaseNote"
          data={releaseData}
          update={(data) => dispatch(updateAdminData(data))}
        />
      )
    default:
      return null
  }
}

export default function AdminSettings () {
  const dispatch = useDispatch()

  const {
    releaseData,
    announcementData,
    refresh,
    load,
    role,
    sid
  } = useSelector(({ adminTool, user }) => ({
    releaseData: adminTool.releaseData,
    announcementData: adminTool.announcementData,
    refresh: adminTool.refresh,
    load: adminTool.load,
    role: user.role,
    sid: user.sid
  }))

  const [currentTab, setCurrentTab] = React.useState('Release Notes')
  const isAdmin = role === 'admin'

  React.useEffect(() => {
    if ((!load || refresh) && isAdmin) {
      dispatch(getAdminData)
    }
  }, [dispatch, load, refresh, isAdmin])

  if (!isAdmin) {
    return (
      <Box mt={3} data-testid="role-message">
        <Typography>
          Hello {sid}, your current role is <em>{role || 'unknown'}</em>. You are not allowed to access the admin page.
        </Typography>
      </Box>
    )
  }

  return (
    <Box data-testid="grid-tab">
      <StyledTabs
        value={currentTab}
        onChange={(e, value) => {
          setCurrentTab(value)
          dispatch({ type: setDialogDataAction.type, payload: null })
        }}
        aria-label="Admin Settings Tabs"
        data-testid='tabs-switching'
        centered align='middle'
      >
        <StyledTab
          value="Release Notes"
          label="Release Notes"
          icon={<LaunchIcon />}
          iconPosition="top"
          data-testid={'tab-release'}
        />
        <StyledTab
          data-testid={'tab-announcements'}
          value="Announcements"
          label="Announcements"
          icon={<AnnouncementIcon />}
          iconPosition="top"
        />
      </StyledTabs>

      <Box mt={2} mb={1}>
        <hr />
      </Box>

      <Box>
        {getTabContents(dispatch, currentTab, releaseData, announcementData)}
      </Box>
    </Box>
  )
}
